import { render, staticRenderFns } from "./textCollapse.vue?vue&type=template&id=7bf30046&scoped=true&"
import script from "./textCollapse.vue?vue&type=script&lang=js&"
export * from "./textCollapse.vue?vue&type=script&lang=js&"
import style0 from "./textCollapse.vue?vue&type=style&index=0&id=7bf30046&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf30046",
  null
  
)

export default component.exports